module.exports = __webpack_public_path__ + "static/media/sleeping.81f8776c.webp";